export default {"src":"/_next/static/media/caret-down.0cb899a6.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};